import React from 'react';
import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'


export default class ListaEmailuri extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <div>

                <ul className='emailuri-clienti'>
                    {this.props.emailuri.map((a, idx2) => {
                        return (<li className='email-container' key={idx2}>

                            {this.props.emailuriToate &&
                                <div>


                                    {a.checked ?
                                        <i onClick={() => { this.props.selecteazaEmail(a) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-email' >check_box</i>
                                        : <i onClick={() => { this.props.selecteazaEmail(a) }} className='material-icons checkbox-email' >check_box_outline_blank</i>
                                    }




                                    <span className='email-nume-selectat'>{a.nume} - {a.email}</span>

                                </div>
                            }

                            {!this.props.emailuriToate &&
                                <div style={{display:'flex', justifyContent:'space-between'}}>

                                    <span className='email-nume'>{a.nume} - {a.email}</span>
                                    <TrashAltSolid onClick={()=>{this.props.deleteEmail(a)}} className=' iconSvg' style={{ marginRight: 0, width: 18, height: 18, color:'black' }} />
                                </div>
                            }

                        </li>)
                    })}
                </ul>

            </div>
        );
    }
}